import { render, staticRenderFns } from "./Plans.vue?vue&type=template&id=88ee403c&"
import script from "./Plans.vue?vue&type=script&lang=js&"
export * from "./Plans.vue?vue&type=script&lang=js&"
import style0 from "./Plans.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88ee403c')) {
      api.createRecord('88ee403c', component.options)
    } else {
      api.reload('88ee403c', component.options)
    }
    module.hot.accept("./Plans.vue?vue&type=template&id=88ee403c&", function () {
      api.rerender('88ee403c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configuration/Plans/Plans.vue"
export default component.exports